import Link from "next/link";
import { FiChevronRight } from "react-icons/fi";
import { MdSchool } from "react-icons/md";
import styles from "./styles/study_area.module.scss";

export const StudyArea = ({ allSpecialization }) => {
  return (
    <section className={styles.section_study_area}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={styles.title}>Choose Your Study Area</h2>
          <ul>
            {allSpecialization?.map((item, i) => (
              <li key={i}>
                <Link
                  legacyBehavior
                  href={`/search?ref=course&sp=${item?.slug}&limit=10&page=1`}
                >
                  <a>
                    <span className={styles.sp_icon}>
                      {item?.icon ? (
                        <img src={item?.icon?.src} alt={item?.icon?.alt} />
                      ) : (
                        <MdSchool />
                      )}
                    </span>
                    <div className={styles.info}>
                      <div className={styles.name}>
                        {item.shortName ?? item.name}
                      </div>
                      <FiChevronRight />
                    </div>
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default StudyArea;
